export default {
  title: {
    ar: '!لم تصل بعد',
    en: 'Not quite there yet!'
  },

  description: {
    ar: '!تحتاج إلى إجابة صحيحة واحدة على الأقل للحصول على فرصة للدخول في السحب. عُد غدًا وحاول مرة أخرى',
    en: 'You need at least 1 correct answer to earn a raffle entry. Come back tomorrow and try again!'
  },

  ok: {
    ar: 'حسنًا',
    en: 'Ok'
  }
};
